import { render, staticRenderFns } from "./reason-show-popup.html?vue&type=template&id=9c5938cc&scoped=true&external"
import script from "./reason-show-popup.js?vue&type=script&lang=js&external"
export * from "./reason-show-popup.js?vue&type=script&lang=js&external"
import style0 from "./reason-show-popup.scss?vue&type=style&index=0&id=9c5938cc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5938cc",
  null
  
)

export default component.exports